export const passwordRegEx =
	/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#~§±`{}()<>;:+=_\\[/|\-^.,'"])[A-Za-z\d@$!%*?&#~§±`{}()<>;:+=_\\[/|\-^.,'[\]"№]{7,}$/;
// TODO move to RegEx folder
